import fetch from "./fetch.js";

function request(url, method, data) {
	switch (method) {
		case "get":
			return fetch({
				method: "get",
				url,
				params: data,
			});
		case "post":
			return fetch({
				method: "post",
				url,
				data,
			});
		case "download":
			return fetch({
				method: "get",
				url,
				params: data,
				responseType: "blob",
			});
		case 'upload':
			return fetch({
				method: 'post',
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				url,
				data
			})
		default:
			return fetch;
	}
}

export default request;